export default __webpack_public_path__ + "static/homepage_carousel_video-2226deb135c95e5ac743c8e0b96fb9ec.mp4";